import { match } from 'ts-pattern'
import {
  CheckboxIcon,
  CodeIcon,
  FontBoldIcon,
  FontItalicIcon,
  ImageIcon,
  Link1Icon,
  ListBulletIcon,
  // PilcrowIcon,
  QuoteIcon,
  StrikethroughIcon,
  TableIcon,
  UnderlineIcon,
  VideoIcon,
} from '@radix-ui/react-icons'
import { CodeBlockIcon } from '~/components/icons/code-block'
import { RichTextOption } from '../../../../../../../../../../../../../packages/tiptap-api-utils/src/options'
import { HighlightIcon } from '~/components/icons/remark-icon'
import { KbdIcon } from '~/components/icons/kbd'
import { SuperscriptIcon } from '~/components/icons/superscript-icon'
import { SubscriptIcon } from '~/components/icons/subscript-icon'

export const RichTextOptionIcon = ({ name }: { name: RichTextOption }) => {
  return (
    match(name)
      .with('bold', () => <FontBoldIcon />)
      .with('italic', () => <FontItalicIcon />)
      .with('strike', () => <StrikethroughIcon />)
      .with('code', () => <CodeIcon />)
      .with('kbd', () => <KbdIcon />)
      .with('link', () => <Link1Icon />)
      .with('h1', () => <>H1</>)
      .with('h2', () => <>H2</>)
      .with('h3', () => <>H3</>)
      .with('h4', () => <>H4</>)
      .with('h5', () => <>H5</>)
      .with('h6', () => <>H6</>)
      // .with('paragraph', () => <PilcrowIcon />)
      .with('codeBlock', () => <CodeBlockIcon className="!size-4" />)
      .with('bulletList', () => <ListBulletIcon />)
      .with('orderedList', () => <>1.</>)
      .with('image', () => <ImageIcon />)
      .with('highlight', () => <HighlightIcon className="size-4" />)
      .with('video', () => <VideoIcon />)
      .with('blockquote', () => <QuoteIcon />)
      .with('table', () => <TableIcon />)
      .with('taskList', () => <CheckboxIcon />)
      .with('superscript', () => <SuperscriptIcon className="ml-px size-4" />)
      .with('subscript', () => <SubscriptIcon className="ml-px size-4" />)
      .with('underline', () => <UnderlineIcon className="ml-px size-4" />)
      .otherwise(() => <></>)
  )
}
